import { getHubSpotDomain, getIsQa } from '../constants/apiEnvironments'; // @ts-expect-error migration error import

import Cookies from 'js-cookie';
import { isGoogleSignup } from '../app/verificationTypeSelectors';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { EndpointKey } from '../http/EndpointKey';
import { isNewLoggedInAccount } from '../http/endpointStateChecks';
import { getQueryParam } from '../routing/getQueryParam';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getEndpointStatus } from '../store/http-responses/selectors';
import { Step } from '../views/Step';
import { GoogleSyncErrorStatus, GoogleSyncErrorStatusByHttpStatus } from './googleContactsSyncConstants';
export const GOOGLE_DATA_SYNC_POPUP_CLOSED = 'OAuthWindowClosed';
export const GOOGLE_CONTACTS_SYNC_ALERT_COOKIE = 'googleContactsSyncAlert';
const GOOGLE_CONTACTS_APP_ID_QA = 1203680;
const GOOGLE_CONTACTS_APP_ID_PROD = 232794;
export const setGoogleContactsSyncAlertCookieForUserGuideAlert = value => {
  const domain = `.${getHubSpotDomain()}`;
  Cookies.set(GOOGLE_CONTACTS_SYNC_ALERT_COOKIE, value, {
    domain,
    path: '/',
    expires: 1 / 8
  });
};
export const getGoogleContactsAppId = () => {
  return getIsQa() ? GOOGLE_CONTACTS_APP_ID_QA : GOOGLE_CONTACTS_APP_ID_PROD;
};
export const getSignupAndLoginRequestsStatus = state => {
  const loginRequestEndpointStatus = getEndpointStatus(state, EndpointKey.LoginBeforeGoogleContactsSync);
  const isUserLoggedIn = isNewLoggedInAccount(state);

  if (loginRequestEndpointStatus) {
    const googleSyncErrorStatus = GoogleSyncErrorStatusByHttpStatus[loginRequestEndpointStatus];

    if (googleSyncErrorStatus === GoogleSyncErrorStatus.Completed) {
      return isUserLoggedIn ? GoogleSyncErrorStatus.Completed : GoogleSyncErrorStatus.Loading;
    }

    return googleSyncErrorStatus;
  }

  return GoogleSyncErrorStatus.Loading;
};
export const shouldAddGoogleContactsSyncStep = state => {
  const googleSignup = isGoogleSignup(state);
  const isQa = getIsQa();
  const queryParam = getQueryParam('should_add_google_sync');
  const shouldAddGoogleSyncStep = getFlowConfig().shouldAddGoogleSyncStep;
  return googleSignup && (shouldAddGoogleSyncStep || isQa && queryParam === 'true');
};
export const getIsGoogleSyncFirstStepAfterAccountCreation = state => {
  const postAccountCreation = getPostAccountCreationSteps(state);
  return postAccountCreation.length ? postAccountCreation[0] === Step.GoogleContactsSync : false;
};